import Vue from "vue"
import VueRouter from "vue-router"

import live from "@/views/live"
import home from "@/views/home"
import welcome from "@/views/welcome"
import vod from "@/views/vod"
import chromecast from "@/views/chromecast"
import chromecastCentral from "@/views/chromecast/central"
import chromecastProxy from "@/views/chromecast/proxy"
import chromecastBuiltin from "@/views/chromecast/builtin"
import chromecastHotspot from "@/views/chromecast/hotspot"
import chromecastSamsung from "@/views/chromecast/samsung"
import prayer from "@/views/prayer"
import flight from "@/views/flight"
import kochealthcare from "@/views/kochealthcare"
import roomImages from "@/views/room/images"
import digitalSignage from "@/views/digitalSignage"
import weather from "@/views/weather"
import store from "@/store"
import news from "@/views/cms/news"
import standby from "@/views/standby"
import feedback from "@/views/feedback"

Vue.use(VueRouter)

const routes = [
  { name: "home", path: "/home", component: home },
  { name: "welcome", path: "/welcome", component: welcome },
  { name: "live", path: "/live/:category?/:scope?/:channel?", component: live },
  { name: "vod", path: "/vod/:target?", component: vod },
  { name: "chromecast", path: "/chromecast", component: chromecast },
  { name: "chromecast-central", path: "/chromecast/central", component: chromecastCentral },
  { name: "chromecast-proxy", path: "/chromecast/proxy", component: chromecastProxy },
  { name: "chromecast-builtin", path: "/chromecast/builtin", component: chromecastBuiltin },
  { name: "chromecast-hotspot", path: "/chromecast/hotspot", component: chromecastHotspot },
  { name: "chromecast-samsung", path: "/chromecast/samsung", component: chromecastSamsung },
  { name: "prayer", path: "/prayer", component: prayer },
  { name: "flight", path: "/flight", component: flight },
  { name: "kochealthcare", path: "/kochealthcare", component: kochealthcare },
  { name: "digitalSignage", path: "/DS", component: digitalSignage },
  { name: "weather", path: "/weather/:city?", component: weather },
  { name: "news", path: "/news", component: news },
  { name: "roomImages", path: "/room/images", component: roomImages },
  { name: "standby", path: "/standby", component: standby },
  { name: "feedback", path: "/feedback", component: feedback }
]

/* CMS Section */
import cmsDetailDefault from "@/views/cms/details/default"
import cmsDetailBoxed from "@/views/cms/details/boxed"
import cmsDetailVideo from "@/views/cms/details/video"
import cmsDetailImage from "@/views/cms/details/image"
import cmsDetail from "@/views/cms/details"
import cmsList from "@/views/cms/"

routes.push({ name: "cmsDetailDefault", path: "/cms/default/:target/:category/:id", component: cmsDetailDefault, props: true })
routes.push({ name: "cmsDetailBoxed", path: "/cms/boxed/:target/:category/:id", component: cmsDetailBoxed, props: true })
routes.push({ name: "cmsDetailVideo", path: "/cms/video/:target/:category/:id", component: cmsDetailVideo, props: true })
routes.push({ name: "cmsDetailImage", path: "/cms/slideshow/:target/:category/:id", component: cmsDetailImage, props: true })
routes.push({ name: "cmsDetail", path: "/cms/:target/:category/:id", component: cmsDetail })
routes.push({ name: "cmsList", path: "/cms/:target/:category?", component: cmsList })

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (!store.state.router) {
    next(false)
    return
  }

  if (!__.guest.welcome() && to.name !== "welcome") {
    next("/welcome")
    return
  } else if (to.name === "welcome" && __.guest.welcome()) {
    next("/")
    return
  }

  _$.nav.disable()
  _$.vue.$emit("beforeRoute", true)
  _$.removeTimeout()

  _$.vue.$emit("channel-list", false)

  await __.platform.fullscreen(false)
  await _$.progress.abortMediaRequest()
  await __.common.tvWindowResize().then(() => _$.sleep(__.device.get("type") === "wixp" ? 1000 : 0))
  await __.platform.background()

  next()
})
router.afterEach((to, from) => {
  if (typeof window.__ === "undefined") return true

  store.state.routerHistory = { to, from }
  _$.sleep(1000).then(() => __.device.isPowerOn() && _$.nav.enable())
  _$.sleep(5000).then(() => _$.vue.$emit("actions", "play"))

  __.platform.clearState()
})

export default router
